import styled from 'styled-components';
import {theme} from '@styles/theme';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
`;

export const HeaderItemWrapper = styled.div<{currentPage?: boolean}>`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  border: 0;
  border-radius: ${theme.roundedMedium};
  background-color: ${({currentPage}) =>
    currentPage ? theme.colors.basic05 : 'transparent'};
  &:hover {
    background-color: ${theme.colors.basic05};
  }
`;
